export default __webpack_public_path__ + "static/media/517.21d28e81.gif";